export default function HeaderIcon(params) {
    const { displayName, innerMethods } = params;
    const headerIconCell = document.createElement('div');
    headerIconCell.classList.add('w5-header-icon-cell');

    const svg = innerMethods?.getSvg ? innerMethods.getSvg() : null;

    if (svg) {
        headerIconCell.innerHTML = svg;
    } else {
        if (displayName) {
            headerIconCell.innerHTML = displayName;
        } else return null;
    }

    return headerIconCell;
}
